import { render, staticRenderFns } from "./WXPay.vue?vue&type=template&id=6d8bcba2&scoped=true&"
import script from "./wx_pay.js?vue&type=script&lang=js&"
export * from "./wx_pay.js?vue&type=script&lang=js&"
import style0 from "./wx_pay.scss?vue&type=style&index=0&id=6d8bcba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8bcba2",
  null
  
)

export default component.exports